<template>
  <div class="checkbox-field-renderer">
    <PCheckbox
      :model-value="modelValue"
      :label="campo.label"
      :error="Boolean(error)"
      :required="campo.obrigatorio"
      :disabled="campo.desabilitado"
      style="width: 100%"
      @update:model-value="(v: boolean) => emit('update:modelValue', v)"
    />
    <span v-if="error" class="checkbox-field-renderer__error">
      {{ error }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { PCheckbox } from "@f360-dev/f360-prisma";
import { TIntegracaoCampoModel } from "../../@types/IntegracaoCampoModel";

defineProps<{
  campo: TIntegracaoCampoModel;
  modelValue: boolean;
  error?: string;
}>();

const emit = defineEmits<{
  (e: "update:modelValue", value: boolean): void;
}>();
</script>

<style scoped lang="scss">
@use "@/ui/styles/theme/f360-theme" as *;

.checkbox-field-renderer {
  width: 100%;

  &__error {
    display: block;
    margin-top: 4px;
    font-weight: 300;
    font-size: 10px;
    line-height: 12px;
    color: $input-icon-color-error;
  }
}
</style>
